import { getDateTime } from '../../../helpers/utils'
import translate from '../../../i18n'
import { IVersion } from '../../../pages/versions-container/share-type'
import { Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { TablePaginationConfig } from 'antd/lib/table/interface'
import { Link } from 'react-router-dom'

interface IProps {
  versions: IVersion[]
  getVersionUrl: (version: IVersion) => string
  showItem?: boolean
  pagination?: false | TablePaginationConfig
  onPaginationChange?: (page: number, pageSize: number) => void
}

const VersionsList = ({
  versions,
  getVersionUrl,
  showItem = false,
  pagination = false,
  onPaginationChange,
}: IProps) => {
  const columns: ColumnsType<IVersion> = [
    {
      title: translate('version.id'),
      dataIndex: 'id',
      key: 'id',
      render: (id: number, version: IVersion) => <Link to={getVersionUrl(version)}>{id}</Link>,
    },
    ...(showItem
      ? [
          { title: translate('version.itemType'), dataIndex: 'itemType', key: 'itemType' },
          { title: translate('version.itemId'), dataIndex: 'itemId', key: 'itemId' },
        ]
      : []),
    { title: translate('version.action'), dataIndex: 'action', key: 'action' },
    {
      title: translate('version.eventName'),
      dataIndex: 'eventName',
      key: 'eventName',
      render: (eventName?: string) => eventName || '-',
    },
    { title: translate('version.who'), dataIndex: 'who', key: 'who' },
    {
      title: translate('version.when'),
      dataIndex: 'createdAt',
      key: 'createdAt',
      render: (createdAt?: string) => (createdAt ? getDateTime(createdAt) : ''),
    },
  ]

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={versions}
      pagination={pagination}
      onChange={
        pagination
          ? paginationConfig =>
              onPaginationChange?.(paginationConfig.current || 1, paginationConfig.pageSize || 10)
          : undefined
      }
      size="small"
    />
  )
}

export default VersionsList
